import { defineMessages } from 'react-intl';

export default defineMessages({

    saveFailedMsg: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Cannot Add Premium Finance',
        defaultMessage: 'Cannot Add Premium Finance',
    },
    deleteFailedTitle: {
        id: 'twia.commercial.premiumFinance.contacts.policyroles.Cannot Delete Premium Finance',
        defaultMessage: 'Cannot Delete Premium Finance',
    },
    cancel: {
        "id": "twia.commercial.premiumFinance.Cancel",
        "defaultMessage": "Cancel"
    },
    removeAdditionalInterest: {
        "id": "twia.commercial.premiumFinance.Remove Additional Interest",
        "defaultMessage": "Remove Additional Interest"
    },
    removeAddlInterestMessage: {
        "id": "twia.commercial.premiumFinance.Are you sure you want to remove this contact?",
        "defaultMessage": "Are you sure you want to remove this contact?"
    },
    premiumFinance: {
        "id": "twia.commercial.premiumFinance.Premium Finance",
        "defaultMessage": "Premium Finance"
    },
    close: {
        "id": "twia.commercial.premiumFinance.additionalInsured.Close",
        "defaultMessage": "Close"
    },
});
